import { config } from '../../../../utils/config';
import addressLogic from '../../../../utils/address/address-logic';

const addressSequenceProps_myAccount = {
    default: ['firstName', ' ', 'lastName', '<br>', 'streetName?<br>', 'additionalStreetInfo?<br>', 'city,state', '<br>', 'postalCode,country', '<br>', 'phone'],
    JP: ['country', '<br>', 'postalCode', '<br>', 'state,city', '<br>', 'streetName?<br>', 'additionalStreetInfo?<br>', 'lastName', ' ','firstName', '<br>', 'phone'],
    HU: ['lastName', ' ', 'firstName', '<br>', 'company?<br>', 'city,state', '<br>', 'streetName?<br>', 'additionalStreetInfo?<br>', 'postalCode', '<br>', 'country', '<br>', 'phone'],
    US: ['firstName', ' ', 'lastName', '<br>', 'streetName?<br>', 'additionalStreetInfo?<br>', 'city,state', ' ', 'postalCode', '<br>', 'phone',' ','extension'],
    CA: ['firstName', ' ', 'lastName', '<br>', 'streetName?<br>', 'additionalStreetInfo?<br>', 'city,state', ' ', 'postalCode', '<br>', 'phone',' ','extension']
};

const getMyAccountAddressSequenceProps = (_country) => {
    if (_country && addressSequenceProps_myAccount[_country.toUpperCase()])
        return addressSequenceProps_myAccount[_country.toUpperCase()];
    return addressSequenceProps_myAccount['default'];
};

export const getMyAccountDisplayAddress = (addressObj) => {
    const allSitesData = addressLogic.getAllSitesData();
    const addressSequence = getMyAccountAddressSequenceProps(config('regionCode'));
    const displayAddress = addressLogic.getDisplayAddress(addressObj, addressSequence, allSitesData);
    return displayAddress;
}

export const generatePdpLinkForLineItem = (pdpData: any, v2selectionAttributes?: any): string => {
    const { slug, productKey, variantId } = pdpData;

    const pdpProductSlug = encodeURIComponent(slug)|| undefined;
    const pdpProductKey = encodeURIComponent(productKey.toLowerCase()) || undefined;

    let pdpLink = `p/${pdpProductSlug}/${pdpProductKey}/`;

    if (v2selectionAttributes && Object.keys(v2selectionAttributes).length > 0) {
        const queryParams:any = [];

        const keyMapping: { [key: string]: string } = {
            "Size": "size",
            "Quantity": "qty"
        };

        Object.entries(v2selectionAttributes).forEach(([key, value]) => {
            const mappedKey = keyMapping[key] || key;
            const encodedKey = encodeURIComponent(mappedKey);
            const encodedValue = encodeURIComponent(String(value));
            queryParams.push(`${encodedKey}=${encodedValue}`);
        });

        pdpLink += `?${queryParams.join('&')}`;
    } else if (variantId) {
        pdpLink += `?variantId=${encodeURIComponent(variantId)}`;
    }

    const siteBaseUrl = config('locale_details').site_baseurl;
    return `${siteBaseUrl}/${pdpLink}`;
};




export const ORDER_ORIGIN = {
    ABC: 'ABC',
    POC: 'POC',
    MATRIX: 'Matrix'
}

export enum GA_EVENT_TYPE {
    MY_ACCOUNT = 'my_account'
}

export const GA_ORDER_PAGE_TYPE = {
  ORDER_DETAILS: 'order-details',
  ORDER_HISTORY: 'my-orders'
}
